/**
 * about.js — ガクモンについて: モーダル・アコーディオンの開閉(P5-1)
 * R90-D: モーダルに dialog セマンティクス(role/aria-modal/ラベル)・フォーカストラップ・
 * Escape クローズ・呼び出し元へのフォーカス復帰を追加(実装パターンは nav.js に準拠)。
 * アコーディオン(.p-sec04__toggle)には aria-expanded / aria-controls を付与。
 */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';
  var openerBtn = null;
  var activeModal = null;

  /** visibility が transition で遅れて可視になるため、フォーカスが乗るまで rAF で再試行(R90 回帰テストで検出) */
  function focusWhenVisible(el) {
    var attempt = 0;
    var tryFocus = function () {
      el.focus();
      if (document.activeElement === el || attempt > 30) return;
      attempt += 1;
      requestAnimationFrame(tryFocus);
    };
    requestAnimationFrame(tryFocus);
  }

  function openModal(modal, btn) {
    openerBtn = btn;
    activeModal = modal;
    modal.setAttribute('aria-hidden', 'false');
    var iframe = modal.querySelector('iframe[data-src]');
    if (iframe && !iframe.src) {
      iframe.src = iframe.getAttribute('data-src');
    }
    var closeBtn = modal.querySelector('.c-chat__modal-close');
    if (closeBtn) focusWhenVisible(closeBtn);
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    var iframe = modal.querySelector('iframe');
    if (iframe && iframe.src) {
      var src = iframe.src;
      iframe.src = src; // 同一 URL を再セット=リロードで動画を停止
    }
    if (openerBtn) { openerBtn.focus(); openerBtn = null; }
    activeModal = null;
  }

  function init() {
    // モーダルへ dialog セマンティクスを付与
    document.querySelectorAll('.c-chat__modal').forEach(function (modal) {
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      var title = modal.querySelector('h3');
      if (title) {
        if (!title.id) title.id = modal.id + '-title';
        modal.setAttribute('aria-labelledby', title.id);
      } else {
        modal.setAttribute('aria-label', '動画');
      }
    });

    // モーダル開閉
    document.querySelectorAll('[data-modal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.getElementById(btn.getAttribute('data-modal'));
        if (modal) openModal(modal, btn);
      });
    });
    document.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        var modal = el.closest('.c-chat__modal');
        if (modal) closeModal(modal);
      });
    });

    // Escape クローズ + フォーカストラップ
    document.addEventListener('keydown', function (e) {
      if (!activeModal) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal(activeModal);
        return;
      }
      if (e.key !== 'Tab') return;
      var nodes = activeModal.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // アコーディオン開閉(aria-expanded / aria-controls 付き)
    document.querySelectorAll('.p-sec04__toggle').forEach(function (btn, i) {
      var content = btn.nextElementSibling;
      if (!content) return;
      if (!content.id) content.id = 'p-sec04-content-' + (i + 1);
      btn.setAttribute('aria-controls', content.id);
      btn.setAttribute('aria-expanded', btn.classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var isOpen = btn.classList.contains('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          content.offsetHeight; // reflow
          content.style.maxHeight = '0';
          content.setAttribute('aria-hidden', 'true');
          btn.classList.remove('is-open');
        } else {
          content.setAttribute('aria-hidden', 'false');
          content.style.maxHeight = content.scrollHeight + 'px';
          btn.classList.add('is-open');
          content.addEventListener('transitionend', function handler() {
            if (btn.classList.contains('is-open')) {
              content.style.maxHeight = 'none';
            }
            content.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
